import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Colors } from '../../../../Styles/Colors';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { ImagePaths } from '../../../../Utility/ImagePaths';

const numbers = Array.from({ length: 11 }, (_, i) => i);

class DocPainScaleRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      painDate: new Date(),
      painValue: "",
      selectedID: null,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    };

    this.painLevel = [
      { value: "(0-1)", image: ImagePaths.noPain.default },
      { value: "(1-3)", image: ImagePaths.mildPain.default },
      { value: "(3-4)", image: ImagePaths.moderatePain.default },
      { value: "(5-7)", image: ImagePaths.severePain.default },
      { value: "(7-9)", image: ImagePaths.verySevere.default },
      { value: "(9-10)", image: ImagePaths.worstPain.default },
    ]
  }

  componentDidMount() {
    if (this.props.EditPainScaleData && Object.keys(this.props.EditPainScaleData).length) {
      this.setState({
        painDate: this.props.EditPainScaleData.pain_chart_date,
        painValue: this.props.EditPainScaleData.pain_level,
        selectedID: this.props.EditPainScaleData.id
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.EditPainScaleData !== this.props.EditPainScaleData) {
      if (this.props.EditPainScaleData && Object.keys(this.props.EditPainScaleData).length) {
        this.setState({
          painDate: this.props.EditPainScaleData.pain_chart_date,
          painValue: this.props.EditPainScaleData.pain_level,
          selectedID: this.props.EditPainScaleData.id
        });
      }
    }
  }

  errorMessage = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      isErrorMsg: true,
      isErrorMsgText: message
    }))
  }
  successMessage = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      successMsg: true,
      successMsgText: message
    }))
  }

  msgClose = () => {
    this.setState((prevState) => ({
      ...prevState,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    }))
  }

  ClearData = () => {
    this.setState((prevState) => ({
      ...prevState,
      painDate: new Date(),
      painValue: "",
      selectedID: null,
    }))
  }

  postPainScale = () => {
    const { t, appointmentId } = this.props
    try {
      let startDate = new Date(this.state.painDate)
      let date = (this.state.painDate) ? DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd") : this.state.painDate
      let Time = (this.state.painDate) ? DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS) : this.state.painDate
      const data = {
        "id": this.state.selectedID ? this.state.selectedID : undefined,
        "appointment_id": appointmentId,
        "nurse_id": null,
        "pain_date": (date + " " + Time),
        "pain_level": this.state.painValue
      }
      if (this.state.painValue === "") {
        this.errorMessage(t("Enter Pain level"))
      } else if (date === "Invalid DateTime") {
        this.errorMessage(t("Invalid Date and Time"))
      } else {
        RestAPIService.create(data, Serviceurls.IP_PAIN_CHART)
          .then((response) => {
            if (response.data.status === "success") {
              this.props.CallgetApi('pain_scale')
              this.ClearData()
              this.successMessage(response.data.message)
            } else {
              this.errorMessage(response.data.message)
            }
          }).catch((error) => {
            this.errorMessage(error.message)
          })
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderDateFilter = () => {
    const { t } = this.props

    return (
      <Box sx={{ marginBottom: "0.5dvw" }}>
        <Box component={'div'} sx={{ backgroundColor: Colors.ThemeLightColor, marginLeft: "1dvw", marginBottom: '0.5vw' }} className='eMed_DocNotes_DateTime' >
          <Typography marginLeft={'0.5vw'} color='#616161' fontWeight={'600'}>{t("DateTime")}</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              inputFormat='DD-MM-YYYY & hh:mm:ss A'
              value={this.state.painDate}
              minDate={new Date()}
              maxDate={new Date()}
              onChange={(newDate) => {
                if (newDate === null) {
                  this.setState((prevState) => ({ ...prevState, painDate: new Date() }))
                }
                else if (newDate > new Date()) {
                  this.setState((prevState) => ({ ...prevState, painDate: new Date() }))
                }
                else {
                  this.setState((prevState) => ({ ...prevState, painDate: newDate }))
                }
              }}
              renderInput={(params) => <TextField size='small'
                {...params}
                fullWidth
                variant='standard'
                className='eMed_DocNotes_datePic_Textfield'
                InputProps={{ 
                  ...params.InputProps, 
                  readOnly: true,
                  onKeyDown: (e) => e.preventDefault()
                }}
              />}
            />
          </LocalizationProvider>
        </Box>
      </Box>
    )
  }

  onImgClick = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      painValue: value
    }))
  }

  rendersmileBtn = (value, image, index) => {
    const isLastImage = index === this.painLevel.length - 1;
    return (
      <Box key={index} position="relative" flex="1" textAlign="center">
        {/* Even Numbers (0, 2, 4, 6, 8, 10) → Above Image */}
        <Typography
          position="absolute"
          top="-3.5dvh"
          left="45%"
          transform="translateX(-50%)"
          fontSize="1vw"
          color="#616161"
        >
          {index * 2}
        </Typography>

        {/* Image */}
        <img
          src={image}
          onClick={() => this.onImgClick(value)}
          className={isLastImage ? "last-image" : ""}
          style={{
            cursor: "pointer",
            width: "100%",
            height: "auto",
            backgroundColor: this.state.painValue === value ? "#04B7B1" : "",
            objectFit: "contain",
            borderRight: "1px solid #E3E2E2"
          }}
          alt="smile"
        />

        {/* Odd Numbers (1, 3, 5, 7, 9) → Between Two Images */}
        {index < this.painLevel.length - 1 && (
          <Typography
            position="absolute"
            top="-3.5dvh"
            left="95%"
            transform="translateX(-50%)"
            fontSize="1vw"
            color="#616161"
          >
            {index * 2 + 1}
          </Typography>
        )}
      </Box>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <Box>
        <Typography className='eMed_refdoc_title'>{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : t("Pain Scale")}</Typography>
        <Box height={"56.3vh"}>
          {this.renderDateFilter()}
          <Typography className='eMed_refdoc_title' sx={{ marginBottom: "0.5vw", backgroundColor: "#FFFF" }}>{t("Pain Level")}</Typography>
          <Box display="flex" flexDirection="column" alignItems="center" width="100%" padding="0.5dvw" marginTop={"0.5dvw"}>
            <Box display="flex" width="100%" justifyContent="center">
              {this.painLevel.map((item, index) => this.rendersmileBtn(item.value, item.image, index))}
            </Box>
          </Box>
        </Box>
        <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"}>
          <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={this.ClearData}>{t("Clear")}</Button>
          <Button variant='contained' size="small" id="eMed_Config_btn" onClick={this.postPainScale}>{t("Add")}</Button>
        </Stack>
        {this.state.isErrorMsg && <ToastMsg
          severity={'error'}
          msg={this.state.isErrorMsgText}
          msgPop={this.msgClose.bind(this)}
        />}
        {this.state.successMsg && <ToastMsg
          severity={'success'}
          msg={this.state.successMsgText}
          msgPop={this.msgClose.bind(this)}
        />}
      </Box>
    )
  }
}
export default withTranslation()(DocPainScaleRight)